import '../upgradeApi.less';

import { Button } from 'antd';
import { useEffect, useState } from 'react';

import IconFailPng from '@/assets/icon/api-management/upgrade-fail.png';
import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';

const handleErrMsgMap = (map: any, errorMsg: any, errorCode: any) => {
  if (map[errorMsg]) {
    map[errorMsg].errorCodes.push(errorCode);
  } else {
    map[errorMsg] = {
      errorMsg,
      errorCodes: [errorCode],
    };
  }
};
const handleErrMsg = (list: string[] = [], t: any) => {
  const msgMap = {};
  list.forEach((code) => {
    const relieveLimitCode = String(code);
    if (['3400051'].indexOf(relieveLimitCode) >= 0) {
      // 您有未关闭的USDT永续仓位或挂单。
      handleErrMsgMap(msgMap, t('utaUpgradeFailOpenUsdt'), relieveLimitCode);
    } else if (['3400054'].indexOf(relieveLimitCode) >= 0) {
      // 您有未取消的USDT永续挂单。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailOpenOrderUsdt'),
        relieveLimitCode,
      );
    } else if (['3400208'].indexOf(relieveLimitCode) >= 0) {
      // 您有未关闭的双向持仓模式或逐仓模式下的USDT永续仓位。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailOpenPositionUsdt'),
        relieveLimitCode,
      );
    } else if (['3400209'].indexOf(relieveLimitCode) >= 0) {
      // 有USDT永续合约持仓时，资金费用结算前后10分钟禁止升级。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailCapitalFeeUsdt'),
        relieveLimitCode,
      );
    } else if (['3400210'].indexOf(relieveLimitCode) >= 0) {
      // 您合约账户当前风险率过高。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailHighRiskCurrent'),
        relieveLimitCode,
      );
    } else if (['3400052'].indexOf(relieveLimitCode) >= 0) {
      // 您有未取消的USDC永续挂单。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailOpenOrderUsdc'),
        relieveLimitCode,
      );
    } else if (['3400053'].indexOf(relieveLimitCode) >= 0) {
      // 您有未取消的USDC期权挂单。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailOpenOrderOption'),
        relieveLimitCode,
      );
    } else if (['3400212'].indexOf(relieveLimitCode) >= 0) {
      // 有USDC永续合约或期权持仓时，资金费用结算或交割前后10分钟禁止升级。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailCapitalFeeUsdc'),
        relieveLimitCode,
      );
    } else if (['3400213'].indexOf(relieveLimitCode) >= 0) {
      // 您USDC合约账户当前风险率过高。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailHighRiskCurrentUsdc'),
        relieveLimitCode,
      );
    } else if (['3400211'].indexOf(relieveLimitCode) >= 0) {
      // 升级后账户风险率过高。
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailHighRiskAfter'),
        relieveLimitCode,
      );
    } else if (['3400049', '3400050'].indexOf(relieveLimitCode) >= 0) {
      // 您有未关闭的USDC永续、期权仓位或挂单。
      handleErrMsgMap(msgMap, t('utaUpgradeFailOpenUsdc'), relieveLimitCode);
    } else if (['3410000'].indexOf(relieveLimitCode) >= 0) {
      // 账户当前存在体验金，暂时无法升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailTrialFund'), relieveLimitCode);
    } else if (['3410001', '3410002'].indexOf(relieveLimitCode) >= 0) {
      // 当前正在LaunchPad[认购/空投]中，请在结束后重新尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailLaunchPad'), relieveLimitCode);
    } else if (['3410003', '3410004'].indexOf(relieveLimitCode) >= 0) {
      // 当前正在ByVotes[投票/空投]中，请在结束后重新尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailByVotes'), relieveLimitCode);
    } else if (['3410005'].indexOf(relieveLimitCode) >= 0) {
      // 您有未关闭的现货交易挂单。
      handleErrMsgMap(msgMap, t('utaUpgradeFailOpenSpot'), relieveLimitCode);
    } else if (['3410006'].indexOf(relieveLimitCode) >= 0) {
      // 您当前在现货账户存在负债。
      handleErrMsgMap(msgMap, t('utaUpgradeFailSpotDebt'), relieveLimitCode);
    } else if (['3410007'].indexOf(relieveLimitCode) >= 0) {
      // 您当前有杠杆交易订单正在被系统强平。
      handleErrMsgMap(msgMap, t('utaUpgradeFailorderLiq'), relieveLimitCode);
    } else if (['3410008'].indexOf(relieveLimitCode) >= 0) {
      // 您在ETP有正在执行申赎的订单。
      handleErrMsgMap(msgMap, t('utaUpgradeFailETP'), relieveLimitCode);
    } else if (['3410009'].indexOf(relieveLimitCode) >= 0) {
      // 您账户当前存在风险，未能成功升级统一账户，详情请咨询客服。
      handleErrMsgMap(msgMap, t('utaUpgradeFailRisk'), relieveLimitCode);
    } else if (['3400072'].indexOf(relieveLimitCode) >= 0) {
      // 场外借贷用户暂不支持升级统一账户
      handleErrMsgMap(msgMap, t('utaUpgradeFailNotSupport'), relieveLimitCode);
    } else if (['3400071'].indexOf(relieveLimitCode) >= 0) {
      // 您的资产未达到升级要求，暂时无法升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailEquity'), relieveLimitCode);
    } else if (['3400069'].indexOf(relieveLimitCode) >= 0) {
      // 您当前正在参与交易比赛，请在比赛结束后尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailCompetition'), relieveLimitCode);
    } else if (['3410013'].indexOf(relieveLimitCode) >= 0) {
      // 升级失败，详情请咨询客服。
      handleErrMsgMap(msgMap, t('utaUpgradeFailCommon'), relieveLimitCode);
    } else if (['3410012'].indexOf(relieveLimitCode) >= 0) {
      // 您账户间当前正在进行划转，请在结束后再尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailTransform'), relieveLimitCode);
    } else if (['3410011'].indexOf(relieveLimitCode) >= 0) {
      // 您账户当前正在进行兑换，请在结束后再尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailExchange'), relieveLimitCode);
    } else if (['3410010'].indexOf(relieveLimitCode) >= 0) {
      // 您账户当前正在进行提现，请在结束后再尝试升级。
      handleErrMsgMap(msgMap, t('utaUpgradeFailWithdraw'), relieveLimitCode);
    } else if (['3400065'].indexOf(relieveLimitCode) >= 0) {
      // 极简链路用户暂不支持升级统一交易账户。
      handleErrMsgMap(msgMap, t('upgradeUTAFailSinpleUser'), relieveLimitCode);
    } else if (['3410016'].indexOf(relieveLimitCode) >= 0) {
      // 您当前在统一保证金账户存在负债。
      handleErrMsgMap(msgMap, t('utaUpgradeFailDebtInUMA'), relieveLimitCode);
    } else if (['3410017'].indexOf(relieveLimitCode) >= 0) {
      // 您有尚未结束的质押借币订单。
      handleErrMsgMap(msgMap, t('utaUpgradeFailBorrowing'), relieveLimitCode);
    } else if (['3400214'].indexOf(relieveLimitCode) >= 0) {
      // 系统处理异常，请稍后再试
      handleErrMsgMap(msgMap, t('utaUpgradeFailSystemError'), relieveLimitCode);
    } else if (['3400215'].indexOf(relieveLimitCode) >= 0) {
      // 有30分钟内将交割的USDC期权，禁止升级
      handleErrMsgMap(msgMap, t('utaUpgradeFailOption30Min'), relieveLimitCode);
    } else if (['3400216'].indexOf(relieveLimitCode) >= 0) {
      // 您有仓位发生了强平，请重新尝试。
      handleErrMsgMap(msgMap, t('utaUpgradeFailLiq'), relieveLimitCode);
    } else if (['3400217'].indexOf(relieveLimitCode) >= 0) {
      // 当前有仓位正在被强平，请稍后再试。
      handleErrMsgMap(msgMap, t('utaUpgradeFailLiqing'), relieveLimitCode);
    } else if (['3410019'].indexOf(relieveLimitCode) >= 0) {
      // 您在放贷宝有正在执行中的订单。
      handleErrMsgMap(msgMap, t('utaFailedCryptoLending'), relieveLimitCode);
    } else if (['3410022'].indexOf(relieveLimitCode) >= 0) {
      // 此账户与您作为交易达人的跟单交易系统关联，无法升级为统一交易账户。
      handleErrMsgMap(msgMap, t('copyTradingCannotUpgrade'), relieveLimitCode);
    } else if (['3401004'].indexOf(relieveLimitCode) >= 0) {
      // 您当前的逐仓强平价风险过高，如有疑问请联系客服
      handleErrMsgMap(msgMap, t('utaUpgradeFailRiskHigh'), relieveLimitCode);
    } else if (['3401005'].indexOf(relieveLimitCode) >= 0) {
      // 您当前的逐仓强平价风险过高，如有疑问请联系客服
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailPositionCheck'),
        relieveLimitCode,
      );
    } else if (['3401006'].indexOf(relieveLimitCode) >= 0) {
      // USDT仓位校验不通过
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailPublicUSDTPositionCheck'),
        relieveLimitCode,
      );
    } else if (['3401007'].indexOf(relieveLimitCode) >= 0) {
      // USDC仓位校验不通过
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailPublicUSDCPositionCheck'),
        relieveLimitCode,
      );
    } else if (['3401008'].indexOf(relieveLimitCode) >= 0) {
      // USDC仓位校验不通过
      handleErrMsgMap(
        msgMap,
        t('utaUpgradeFailHasOpenOrder'),
        relieveLimitCode,
      );
    } else if (['3400322'].indexOf(relieveLimitCode) >= 0) {
      // 当前暂不支持升级到UTA Pro，请通过反向合约账户升级到新的UTA版本（含反向合约）后再次尝试
      handleErrMsgMap(msgMap, t('utaUpgradeFail3400322'), relieveLimitCode);
    } else {
      // 升级失败，详情请咨询客服。
      handleErrMsgMap(msgMap, t('utaUpgradeFailCommon'), relieveLimitCode);
    }
  });

  return msgMap;
};

const FailModal = ({
  visible,
  onConfirm,
  failCodes,
}: {
  visible: boolean;
  failCodes: string[];
  onConfirm: () => void;
}) => {
  const [$t] = useI18nContext();
  const [failMsg, setFailMsg] = useState<
    { errorMsg: string; errorCodes: string[] }[]
  >([]);

  useEffect(() => {
    if (Array.isArray(failCodes)) {
      const msgMap = handleErrMsg(failCodes, (key: string) => $t(key));
      setFailMsg(Object.values(msgMap));
    }
  }, [failCodes, $t]);

  return (
    <ByModal
      visible={visible}
      modalProps={{ centered: true }}
      ByFooter={[
        <div className="upgrade-api__fail--footer" key="footer">
          <Button
            onClick={onConfirm}
            key="confirm"
            type="primary"
            className="bybit-btn-primary"
          >
            {$t('Confirm')}
          </Button>
        </div>,
      ]}
      classNames="upgrade-api__fail"
      title={null}
      newStyle
    >
      <div className="upgrade-api__fail--fail">
        <img src={IconFailPng} alt="" />
      </div>
      <h4>{$t('UpgradeToApiProFail.title')}</h4>
      <ul>
        {failMsg.map((item: any) => (
          <li key={item.errorMsg}>{item.errorMsg}</li>
        ))}
      </ul>
    </ByModal>
  );
};

export default FailModal;
